export default __webpack_public_path__ + "static/icon-supply-chain-219cf34f43f3e9e594ffcb3e350013e9.svg";